import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import ManageSIFormProperties from './ManageSIFormProperties'
import { components } from 'cng-web-lib'
import pathMap from 'src/paths/PathMap_ShippingInstruction'

const {
  form: { CngViewForm }
} = components

function ManageSIPage({ showNotification }) {
  const { id } = useParams()
  const history = useHistory()

  function onSubmit(data) {
    console.log('submit', data)

    history.push('/')
    history.replace({ pathname: pathMap.MY_SI, state: data })
  }

  return (
    // use CngViewForm here for customizable button set
    <CngViewForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      history={history}
      showNotification={showNotification}
      bodySection={
        <ManageSIFormProperties.FormFields
          disabled={false}
          showNotification={showNotification}
        />
      }
      formikProps={{
        ...ManageSIFormProperties.formikProps,
        onSubmit: onSubmit
      }}
      // toClientDataFormat={PollingFormProperties.toClientDataFormat}
      // toServerDataFormat={PollingFormProperties.toServerDataFormat}
    />
  )
}

export default ManageSIPage
